class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    // this.overlay = this.querySelector('.details-modal-overlay');
    this.productItem = this.querySelectorAll('.predictive-search__suggestions-item') || ''
    this.topAppContainer = ''

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => (event.code) ? event.code.toUpperCase() === 'ESCAPE' && this.close() : ''
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('.modal__close-button')?.addEventListener(
      'click',
      this.close.bind(this)
    );
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();

    const isModalOpen = event.target.closest('details').hasAttribute('open');

    // 查找顶部容器，然后决定打开或关闭
    this.findTopContainer()
      .then(container => {
        this.topAppContainer = container;

        if (isModalOpen) {
          this.close();
        } else {
          // 隐藏顶部容器
          if (this.topAppContainer) {
            this.topAppContainer.style.display = 'none';
          }
          this.open(event);
        }
      })
      .catch(() => {
        // 顶部容器未找到，仍然切换模态框状态
        if (isModalOpen) {
          this.close();
        } else {
          this.open(event);
        }
      });
  }
  /**
 * 查找顶部容器元素
 */
  findTopContainer() {
    return this.waitForElement('#epb_container');
  }

  open(event) {
    if (event) {
      event.target.closest('details').setAttribute('open', true);
      //product item动画
      if (this.productItem) {
        this.productItem.forEach((item) => {
          item.classList.add('predictive-search__suggestions-item-animation');
        })
      }
    }

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    // 添加防御性检查
    const focusElement = this.detailsContainer.querySelector('[tabindex="-1"]');
    const fallbackElement = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (focusElement || fallbackElement) {
      trapFocus(focusElement, fallbackElement);
    } else {
      // 如果没有合适的元素，可以使用容器本身
      this.detailsContainer.setAttribute('tabindex', '-1');
      trapFocus(this.detailsContainer);
    }

  }

  close(focusToggle = true) {
    // 显示top滚动插件
    this.topAppContainer ? this.topAppContainer.style.display = 'block' : '';
    //product动画
    if (this.productItem) {
      this.productItem.forEach((item) => {
        item.classList.remove('predictive-search__suggestions-item-animation');
      })
    }
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }


  /**
   * 等待元素出现在DOM中
   * @param {string} selector - CSS选择器
   * @param {number} timeout - 超时时间(毫秒)
   * @return {Promise} 解析为找到的元素
   */
  waitForElement(selector, timeout = 5000) {
    return new Promise((resolve, reject) => {
      // 立即检查元素是否存在
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }

      // 使用MutationObserver监听DOM变化
      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector);
        if (element) {
          observer.disconnect();
          resolve(element);
        }
      });

      // 配置观察器
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // 设置超时
      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found within ${timeout}ms`));
      }, timeout);
    });
  }
}

customElements.define('details-modal', DetailsModal);